import { BrowserRouter as Router, useRoutes } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import { Toaster, ToastBar, toast } from "react-hot-toast";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { ColorModeProvider } from "./providers/ColorModeProvider";
import { TrpcProvider } from "./providers/TrpcProvider";
import { AuthProvider } from "./providers/auth";
import KeyboardShortcutsProvider from "./components/KeyboardShortcutsProvider";
import routes from "./routes";

// AppRoutes component to use the routes configuration
const AppRoutes = () => {
  const routeElements = useRoutes(routes);
  return routeElements;
};

function App() {
  return (
    <ColorModeProvider>
      <CssBaseline />
      {/*
        Toast behavior (#26): users multitask, so a vanished error reads as
        "no response". Errors persist until the user dismisses them; info and
        success toasts get a longer (still auto-dismiss) timeout. Every toast
        gets an explicit dismiss button.
      */}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 6000, // default (info) — longer than the 4s library default
          success: { duration: 5000 },
          error: { duration: Infinity }, // persist until dismissed
        }}
      >
        {(t) => (
          <ToastBar toast={t}>
            {({ icon, message }) => (
              <div className="flex items-start gap-2">
                {icon}
                <div className="flex-1">{message}</div>
                {t.type !== "loading" && (
                  <button
                    type="button"
                    onClick={() => toast.dismiss(t.id)}
                    aria-label="Dismiss notification"
                    className="ml-1 shrink-0 self-start rounded p-0.5 text-gray-400 hover:text-gray-700 dark:hover:text-gray-200"
                  >
                    <XMarkIcon className="h-4 w-4" />
                  </button>
                )}
              </div>
            )}
          </ToastBar>
        )}
      </Toaster>
      <TrpcProvider>
        <AuthProvider>
          <Router>
            <KeyboardShortcutsProvider>
              <AppRoutes />
            </KeyboardShortcutsProvider>
          </Router>
        </AuthProvider>
      </TrpcProvider>
    </ColorModeProvider>
  );
}

export default App;
